module.exports = __webpack_public_path__ + "static/assets/a86dc7e23b0b7d455cff4bdb4515ebf0.png";